import {
  api_get_process_list_url,
  api_create_process_url,
  api_update_process_url,
  api_activate_deactivate_process_url,
  api_get_process_details_url
} from "./processApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  parser_get_process_list,
  parser_create_process,
  parser_update_process,
  parser_activate_deactivate_process,
  parser_get_process_details
} from "./processParser";
import { PAGE } from "../../helpers/constants";

export const get_process_list = createAsyncThunk(
  "get_process_list",
  async (payload) => {
    try {
      const { page, limit, qn, qs } = payload
      const response = await api_get_process_list_url(page, limit, qn, qs);
      const data = parser_get_process_list(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const create_process = createAsyncThunk(
  "create_process",
  async (payload) => {
    try {
      const { process_name, process_email, display_order, process_logo } = payload
      const formData = new FormData();
      formData.append("process_name", process_name);
      formData.append("process_email", process_email);
      formData.append("display_order", display_order);
      if (payload.process_logo) {
        formData.append("process_logo", process_logo);
      }
      const response = await api_create_process_url(formData);
      const data = parser_create_process(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const update_process = createAsyncThunk(
  "update_process",
  async (payload) => {
    try {
      const { process_id, updated_data } = payload
      const formData = new FormData();
      if (updated_data.process_name) {
        formData.append("process_name", updated_data.process_name);
      }
      if (updated_data.process_email) {
        formData.append("process_email", updated_data.process_email);
      }
      if (updated_data.display_order) {
        formData.append("display_order", updated_data.display_order);
      }
      if (updated_data.process_logo) {
        formData.append("process_logo", updated_data.process_logo);
      }
      const response = await api_update_process_url(process_id, formData);
      const data = parser_update_process(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const activate_deactivate_process = createAsyncThunk(
  "activate_deactivate_process",
  async (payload) => {
    try {
      const { process_id, updated_data } = payload
      const response = await api_activate_deactivate_process_url(process_id, updated_data)
      const data = parser_activate_deactivate_process(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const get_process_details = createAsyncThunk(
  "get_process_details",
  async (payload) => {
    try {
      const response = await api_get_process_details_url(payload);
      const data = parser_get_process_details(response);
      return { data };
    } catch (error) {
      throw new Error(error);
    }
  }
);

const initialState = {
  common_loading: false,
  is_process_modal_open: false,
  selected_status: '',
  search_query: '',
  selected_data: null,
  c_action: null,
  process_id: null,
  process_list: [],
  total_process_count: 0,
  active_process: 0,
  page: PAGE - 1
};

export const processSlice = createSlice({
  name: "process",
  initialState,
  reducers: {
    setProcessPage: (state, action) => {
      state.page = action.payload;
    },
    setProcessModalOpen: (state, action) => {
      state.is_process_modal_open = action.payload;
    },
    setAction: (state, action) => {
      state.c_action = action.payload;
    },
    setId: (state, action) => {
      state.process_id = action.payload;
    },
    setStatus: (state, action) => {
      state.selected_status = action.payload ? action.payload : '';
    },
    setSearchQuery: (state, action) => {
      state.search_query = action.payload;
    }
  },
  extraReducers: (builder) => {
    // get process list
    builder.addCase(get_process_list.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_process_list.fulfilled, (state, action) => {
      state.common_loading = false;
      state.process_list = action.payload.data.process;
      state.total_process_count = action.payload.data.total_count;
      state.active_process = action.payload.data.process.filter(process => process.is_active === true).length;
    })
    builder.addCase(get_process_list.rejected, (state) => {
      state.common_loading = false;
    })
    //create process
    builder.addCase(create_process.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(create_process.fulfilled, (state, action) => {
      state.common_loading = false;
      state.process_list.push(action.payload.data)
    })
    builder.addCase(create_process.rejected, (state) => {
      state.common_loading = false;
    })
    //update process
    builder.addCase(update_process.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(update_process.fulfilled, (state, action) => {
      state.common_loading = false;
      state.process_list = state.process_list.map((process) =>
        process.id === action.payload.data.id ? { ...process, ...action.payload.data } : process
      );
    })
    builder.addCase(update_process.rejected, (state) => {
      state.common_loading = false;
    })
    // activate_deactivate_process
    builder.addCase(activate_deactivate_process.pending, (state) => {
      state.common_loading = true;
    });
    builder.addCase(activate_deactivate_process.fulfilled, (state, action) => {
      state.common_loading = false;
      state.process_list = state.process_list.map((process) =>
        process.id === action.payload.data.id ? { ...process, ...action.payload.data } : process
      );
    });
    builder.addCase(activate_deactivate_process.rejected, (state) => {
      state.common_loading = false;
    })
    //get process details
    builder.addCase(get_process_details.pending, (state) => {
      state.common_loading = true;
    })
    builder.addCase(get_process_details.fulfilled, (state, action) => {
      state.common_loading = false;
      state.selected_data = action.payload.data
    })
    builder.addCase(get_process_details.rejected, (state) => {
      state.common_loading = false;
    })
  },
});

// Action creators are generated for each case reducer function
export const {
  setProcessModalOpen,
  setProcessPage,
  setAction,
  setId,
  setStatus,
  setSearchQuery
} = processSlice.actions;
export default processSlice.reducer;                            
